import * as lazyPages from './pages'
import { usePreloadLazy } from './utils'

export const usePreloadLazyComponents = () => usePreloadLazy(Object.values(lazyPages))
